import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-dialog-device-notify-confirmation',
    templateUrl: './dialog-device-notify-confirmation.component.html',
    styleUrls: ['./dialog-device-notify-confirmation.component.css'],
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatButton,
        TranslateModule,
    ]
})
export class DialogDeviceNotifyConfirmationComponent {
	public title: string;
	public confirmMessage: string;

	constructor(
		public dialogRef: MatDialogRef<DialogDeviceNotifyConfirmationComponent>
	) {}

	close() {
		this.dialogRef.close(false);
	}

	save() {
		this.dialogRef.close(true);
	}
}
